import { Datagrid, List, TextField } from "react-admin";

function CourseFolderList(props) {
  return (
    <List {...props}>
      <Datagrid>
        <TextField source="id" />
        <TextField source="name" />
      </Datagrid>
    </List>
  );
}

export default CourseFolderList;
